<template>
    <div>
        <nav-bar></nav-bar>

        <div class="container">

            <div class="section">

                <nav class="breadcrumb" aria-label="breadcrumbs">
                    <ul>
                      <li><a @click="$router.push('/clients')">Chatbots</a></li>
                      <li><a @click="$router.push('/clients/'+client+'/intents')">{{clientName}}</a></li>
                      <li><a @click="$router.push('/clients/'+client+'/intents/'+intent+'/sentences')">Frases</a></li>
                      <li class="is-active"><a href="#" aria-current="page">Actualizar Frase</a></li>
                    </ul>
                </nav>

                <div class="field">
                    <label class="label">Frase</label>
                    <div class="control">
                        <input class="input" type="text" placeholder="Frase" v-model="sentence.term">
                    </div>
                </div>

                <div class="field">
                    <label class="label">Keywords</label>
                    <div class="control">
                        <input class="input" type="text" placeholder="Keywords separadas por comas" v-model="sentence.keywords">
                    </div>
                </div>

                <div class="field">
                    <label class="label">Prioridad</label>
                    <div class="control">
                        <input class="input" type="number" placeholder="Prioridad" v-model="sentence.priority">
                    </div>
                </div>

                <div class="field">
                    <label class="label">Idioma</label>
                    <div class="control">
                        <div class="select is-medium">
                            <select v-model="sentence.languageId">
                              <option v-for="language in languages" :key="language.idLanguage" :value="language.idLanguage">
                                {{language.language}}
                              </option>
                            </select>
                        </div>
                    </div>
                </div>

                <div class="field">
                    <label class="label">Finaliza el Bot</label>
                    <div class="control">
                        <div class="select is-medium">
                            <select v-model="sentence.finishBot">
                                <option :value="0">No</option>
                                <option :value="1">Sí</option>
                            </select>
                        </div>
                    </div>
                </div>
                <br>

                <div class="button is-primary is-left" @click="storeIntent">
                    <span class="icon"><i class="fas fa-save fa-lg"></i></span>
                    <span class="is-capitalized">Guardar</span>
                </div>
            </div>

        </div>
    </div>

</template>

<script>
export default {
  data () {
    return {
      client: this.$route.params.client,
      clientName: 'Chatbot',
      intent: this.$route.params.intent,
      intentName: 'Intención',
      sentenceId: this.$route.params.sentence,
      sentence: {},
      languages: {},
      language: null
    }
  },
  created () {
    this.getSentence()
    this.getLanguages()
    this.breadcrumbDetails()
  },
  methods: {
    breadcrumbDetails () {
      this.api.post('/ClientById/', {idClient: this.client}).then(response => {
        this.clientName = response.client.name
      })
      this.api.post('/IntentById', {idIntent: this.$route.params.intent}).then(response => {
        this.intentName = response.intent.name
      })
    },
    getSentence () {
      this.api.post('/PhraseById', {idDictionary: this.sentenceId}).then(response => {
        this.sentence = response.phrase
      })
    },
    getLanguages () {
      this.api.post('/DataLanguageList').then(response => {
        this.languages = response.languages
      })
    },
    storeIntent () {
      if (this.sentence.languageId === this.languages[0].idLanguage) {
        Event.$emit('showModal', 'Es necesario elegir un idioma')
        return
      }
      this.api.post('/PhraseUpdate', this.sentence).then(() => {
        this.$router.back()
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Intents/sentencesAndAnswers/sentences/UpdateSentence.vue